/**
 * Selectable UI themes.
 *
 * A theme is more than a palette here. Each one also swaps geometry
 * (corner treatment, card shape, how the app list is laid out) via
 * `[data-theme='…']` blocks in src/styles/themes.css.
 *
 * `swatch` drives the little preview dot in the picker.
 */

export const THEMES = [
    {
        id: 'classic-dark',
        name: 'Classic',
        variant: 'Dark',
        note: 'Soft glass cards and a drifting aurora.',
        swatch: ['#0b0d16', '#6366f1', '#22d3ee'],
    },
    {
        id: 'classic-light',
        name: 'Classic',
        variant: 'Light',
        note: 'The same shapes, lit for daytime.',
        swatch: ['#f6f7fb', '#6366f1', '#22d3ee'],
    },
    {
        id: 'aero',
        name: 'Frutiger Aero',
        variant: 'Sky',
        note: 'Glossy capsules, bubbles and 2000s optimism.',
        swatch: ['#bde5fb', '#37b0f0', '#ffffff'],
    },
    {
        id: 'deep',
        name: 'Deep Field',
        variant: 'Midnight',
        note: 'Chamfered panels and cold neon hairlines.',
        swatch: ['#050b1c', '#1e6ef0', '#37e6ff'],
    },
    {
        id: 'blade',
        name: 'Blade',
        variant: 'Emerald',
        note: 'Long selectors and a green glow, circa 2001.',
        swatch: ['#040a04', '#7cd200', '#c6ff43'],
    },
    {
        id: 'voxel',
        name: 'Voxel',
        variant: 'CRT',
        note: 'Untextured polygons behind a mistuned tube.',
        swatch: ['#090416', '#ff2fb0', '#00e8ff'],
    },
];

export const DEFAULT_THEME = 'classic-dark';
export const STORAGE_KEY = 'support-theme';

const VALID = new Set(THEMES.map(theme => theme.id));

/** Values written by the earlier two-state toggle. */
const LEGACY = { dark: 'classic-dark', light: 'classic-light' };

/** Coerce anything stored (or stale) into a real theme id. */
export const normalizeTheme = value => {
    if (VALID.has(value)) return value;
    if (LEGACY[value]) return LEGACY[value];
    return null;
};

export const getTheme = id => THEMES.find(theme => theme.id === id);
